import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { KYCBanner } from '@atlas/components';
import {
  isUserNeedKyc,
  needsBankAccounts,
  NotificationManager,
  useApplicationState,
} from '@atlas/core';
import { BasePopup, Button, Icon, Label } from '@atlas/ui';

import VerificationButton from 'src/components/Verification/VerificationButton';

const defaultModalText = {
  btnText: 'go_to_kyc',
  description: 'kyc_verification_description',
  title: 'kyc_popup_title',
};

const VerificationPopup = ({ data, id }) => {
  const { account, bankAccounts } = useApplicationState();

  const modalText = useMemo(() => {
    if (isUserNeedKyc(account)) {
      return defaultModalText;
    }

    if (needsBankAccounts(bankAccounts)) {
      return {
        btnText: 'kyc_popup_register_bank_account_button',
        description: 'kyc_popup_register_bank_account_descriprion',
        title: 'kyc_popup_register_bank_account_title',
      };
    }

    return defaultModalText;
  }, [account, bankAccounts]);

  const handleClose = useCallback(() => NotificationManager.removeNotification(id), [id]);

  return (
    <BasePopup className="kyc-verification-popup" onClose={handleClose}>
      <Button className="kyc-verification-block-close" onClick={handleClose}>
        <Icon name="close" />
      </Button>
      <KYCBanner
        button={
          <VerificationButton
            isTerminal={data?.isTerminal}
            label={modalText.btnText}
            onClick={handleClose}
          />
        }
        className="kyc-popup"
        description={
          <Label className="kyc-verification-popup-description" message={modalText.description} />
        }
        icon={<Icon height={32} name="security-legitimuz" width={32} />}
        layout="vertical"
        title={<Label className="kyc-verification-popup-title" message={modalText.title} />}
      />
    </BasePopup>
  );
};

VerificationPopup.propTypes = {
  data: PropTypes.shape({
    isTerminal: PropTypes.bool,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default VerificationPopup;
